module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/logradouro/logradouro.component.css
// module id = ./src/app/logradouro/logradouro.component.css
// module chunks = main